export default {
  exam: {},
  exams: [],
  orgDistributedQuotes: [],
}
